import Template from './experience.njk';
import Marionette from "backbone.marionette";
import moment from 'moment-timezone';
import 'moment-duration-format';
import _ from "underscore";
import { EventSummaryDemographicsView } from "./components/EventSummary/EventSummaryDemographicsView";

/**
 * @param {model} Experience
 */
export default Marionette.View.extend({
  template: Template,
    modelEvents: {
        'change:duration': 'render',
        'change:name': 'render',
    },

    regions: {
        demographics: ".demographics"
    },

    initialize(options) {
        this.event = options.event;
        this.settings = options.settings;
    },

    onRender() {
        if (this.settings.events.showDemographics) {
            this.showChildView("demographics", new EventSummaryDemographicsView({
                model: this.event,
                settings: this.settings
            }));
        }
    },

    templateContext() {
        var duration = this.model.get('eventDuration');
        if (duration == null) {
            duration = this.model.get('duration');
        }
        var filteredName = this.model.get("name");
        var settings = this.settings;

        if (settings.events.nameOverrides.hasOwnProperty(this.model.id)) {
            filteredName = settings.events.nameOverrides[this.model.id];
        }

        var guideList = [];

        if (this.options.guides) {
            _.each(this.options.guides, (guide) => {
                if (guide) {
                    guideList.push(guide.get("name"));
                }
            });
        }

        return {
            filteredName: filteredName,
            duration: moment.duration(duration, 'minutes').format("d [day] h [hour] m [minute]", {trim: "all"}),
            guideList: guideList.join(','),
            settings: settings
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/view/experience.js